<template>
  <table class="table--small">
    <thead>
      <tr>
        <th style="width: 120px; min-width: 12px;">{{ layerType.layer_type.name }}</th>
        <th
          style="width: 100px; min-width: 100px;"
        >{{ $t('placementtype.' + layerType.placement_type)}}</th>
        <th>{{ layerType.subtype }} {{ layerType.thickness }} {{ $t('cm') }}</th>
        <th
          style="width: 100px; min-width: 100px;"
          class="text-right"
        >{{ $helpers.formatNumber(layerType.qm) }} {{ $t('qm') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(layerLog, index) in layerLogs" :key="index">
        <template v-if="isVisibleLayerLog(layerLog)">
          <td style="width: 120px; min-width: 120px;">
            <span class="table-status">
              <span class="status-icon" :class="'status-icon--' + layerLog.status"></span>
              {{ $t('status.' + layerLog.status + '_short') }}
            </span>
          </td>
          <td style="width: 125px; min-width: 125px;">
            <template
              v-if="layerLog.status === 'open'"
            >{{ $helpers.formatNumber(layerLog.qm) }} {{ $t('qm') }}</template>
            <template v-else>
              <template v-if="!isVisibleLayerLogUpdate(layerLog)">
                {{ $helpers.formatNumber(layerLog.qm) }} {{ $t('qm') }}
                <template
                  v-if="$store.getters.userHasPermission('project_qm_update') && !isCancelled"
                >
                  <button
                    role="button"
                    class="button button--action button--action--edit button--small"
                    :title="$t('update')"
                    @click="onUpdateLayerLog(layerLog)"
                  >{{ $t('update') }}</button>
                </template>
              </template>
              <template v-else>
                <template
                  v-if="$store.getters.userHasPermission('project_qm_update') && !isCancelled"
                >
                  <input
                    type="text"
                    class="form-control form-control--extra-small"
                    :placeholder="$t('form.project.layer.log.area.plc')"
                    v-model="layerLog.qm"
                  />
                  <button
                    role="button"
                    class="button button--action button--action--delete button--small"
                    :title="$t('delete')"
                    @click="onDeleteLayerLog(layerLog)"
                  >{{ $t('delete') }}</button>
                </template>
              </template>
            </template>
          </td>
          <td colspan="2" class="text-right">
            <template v-if="layerLog.status === 'open'">
              <template
                v-if="$store.getters.userHasPermission('project_qm_update') && !isCancelled"
              >
                <div class="grid-x grid-margin-x align-right">
                  <div class="cell">
                    <button
                      role="button"
                      class="button button--save button--extra-small"
                      :title="$t('form.submit.save')"
                      @click="onOpenFinishReveal"
                    >{{ $t('form.submit.save') }}</button>
                  </div>
                  <div class="cell form-group">
                    <input
                      type="text"
                      class="form-control form-control--extra-small"
                      :placeholder="$t('form.project.layer.log.area.plc')"
                      v-model="layerValue.qm"
                    />
                  </div>
                  <div class="cell form-group">
                    <v-datepicker
                      class="form-control form-control--extra-small form-control--date"
                      :format="$helpers.dateFormat"
                      v-model="layerValue.date.date"
                      :disabledDates="{ from : new Date() }"
                    />
                  </div>
                </div>
              </template>
            </template>
            <template
              v-else-if="layerLog.date.date !== null"
            >{{ layerLog.date.date | moment($helpers.dateFormat.toUpperCase()) }}</template>
            <div
              class="reveal reveal--body"
              :id="'finish-object-' + layerType.id + '-reveal'"
              data-reveal
            >
              <div class="reveal--body__content">
                <h2>
                  {{ $t('form.project.layer.finish.title', {
                  layer : layerType.layer_type.name
                  }) }}
                </h2>
                <p>
                  {{ $t('form.project.layer.finish.content', {
                  total : $helpers.formatNumber(object.total),
                  finished : $helpers.formatNumber(object.finished)
                  }) }}
                </p>
                <div class="form">
                  <div class="form-group">
                    <textarea
                      class="form-control--textarea"
                      :placeholder="$t('form.project.layer.log.comment.plc')"
                      v-model="object.comment"
                    ></textarea>
                  </div>
                  <div class="form-group">
                    <button
                      role="button"
                      type="submit"
                      class="button"
                      :title="$t('form.submit.confirm')"
                      :disabled="objectFormDisabled"
                      @click="onSubmitFinishObject"
                    >{{ $t('form.submit.confirm') }}</button>
                  </div>
                </div>
              </div>
              <button class="close-button" data-close aria-label="Close modal" type="button">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </td>
        </template>
      </tr>
    </tbody>
  </table>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  props: {
    layerType: {
      type: Object,
      default: {}
    },
    layerValue: {
      type: Object,
      default: {}
    },
    cancelled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      layerLogs: [],
      showAllLayerLogs: false,
      visibleLayerLogs: [],
      objectFormDisabled: false,
      object: {
        comment: "",
        total: 0,
        finished: 0,
        open: 0
      }
    };
  },
  components: {
    vDatepicker: Datepicker
  },
  mounted: function() {
    this.reveal = new Foundation.Reveal(
      $("#finish-object-" + this.layerType.id + "-reveal"),
      {
        vOffset: 50
      }
    );
  },
  computed: {
    isCancelled: function() {
      return this.cancelled;
    }
  },
  created: function() {
    this.onUpdateLayerLogs();
  },
  methods: {
    onUpdateLayerLogs: function() {
      this.layerLogs = [];
      this.object.total = parseInt(this.layerType.qm);
      this.object.open = parseInt(this.layerType.qm);
      this.object.finished = 0;

      if (this.layerType.layer_logs) {
        this.layerType.layer_logs.forEach(
          function(layerLog) {
            this.object.finished += parseInt(layerLog.qm);
            this.object.open -= parseInt(layerLog.qm);

            layerLog.status = "busy";

            this.layerLogs.push(layerLog);
          }.bind(this)
        );
      }

      if (
        ["finished", "finished_manual"].indexOf(this.layerType.status) !== -1
      ) {
        this.layerLogs.push({
          status: "finished",
          qm: this.object.finished,
          date: {
            date: this.layerType.status_date.date
          },
          manual: this.layerType.status === "finished_manual"
        });
      } else {
        this.layerLogs.push({
          status: "open",
          qm: this.object.open,
          date: {
            date: null
          }
        });
      }
    },
    isVisibleLayerLog: function(layerLog) {
      if (layerLog.status === "finished") {
        return true;
      }

      if (this.showAllLayerLogs) {
        return true;
      }

      if (
        ["finished", "finished_manual"].indexOf(this.layerType.status) === -1
      ) {
        return true;
      }

      return false;
    },
    isVisibleLayerLogUpdate: function(layerLog) {
      if (layerLog.status !== "finished") {
        if (this.showAllLayerLogs) {
          return true;
        }

        if (this.visibleLayerLogs.indexOf(layerLog.id) !== -1) {
          return true;
        }
      }

      return false;
    },
    onUpdateLayerLog: function(layerLog) {
      if (layerLog.status === "finished") {
        this.showAllLayerLogs = !this.showAllLayerLogs;

        if (layerLog.manual) {
          this.layerLogs = [
            {
              status: "open",
              qm: this.object.open,
              date: {
                date: null
              }
            }
          ];

          this.layerType.status = "open";

          this.$emit("onFinishLayer", this.layerType);
        }
      } else {
        if (this.visibleLayerLogs.indexOf(layerLog.id) === -1) {
          this.visibleLayerLogs.push(layerLog.id);
        } else {
          this.visibleLayerLogs.splice(
            this.visibleLayerLogs.indexOf(layerLog.id),
            1
          );
        }
      }
    },
    onDeleteLayerLog: function(layerLog) {
      if (this.layerType.layer_logs) {
        this.layerLogs.forEach(
          function(item, index) {
            if (layerLog.id === item.id) {
              this.layerLogs.splice(index, 1);
            }
          }.bind(this)
        );

        this.layerType.layer_logs.forEach(
          function(item, index) {
            if (layerLog.id === item.id) {
              this.layerType.layer_logs.splice(index, 1);
            }
          }.bind(this)
        );
      }
    },
    onOpenFinishReveal: function() {
      this.reveal.open();
    },
    onCloseFinishReveal: function() {
      this.reveal.close();
    },
    onSubmitFinishObject: function() {
      this.layerType.status = "finished_manual";
      this.layerType.comment = this.object.comment;

      this.layerLogs.push({
        status: "finished",
        qm: this.object.open,
        date: {
          date: this.$moment().format("YYYY-MM-DD hh:mm:ss")
        }
      });

      this.$emit("onFinishLayer", this.layerType);

      this.onCloseFinishReveal();
    }
  }
};
</script>